var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attachList.length === 0) ? _c('div', [_vm._v("\n    -\n")]) : _c('div', [(_vm.attachList.length === 1) ? _c('div', [_c('p', [(_vm.attachList[0].preUrl) ? _c('a', {
    staticClass: "attachName",
    attrs: {
      "target": "_blank",
      "href": _vm.attachList[0].preUrl,
      "title": _vm.attachList[0].name
    }
  }, [_vm._v(_vm._s(_vm.attachList[0].name))]) : _c('span', {
    staticClass: "attachName",
    attrs: {
      "title": _vm.attachList[0].name
    }
  }, [_vm._v(_vm._s(_vm.attachList[0].name))]), _vm._v(" "), _c('a', {
    staticClass: "ml-10 mr-10",
    attrs: {
      "href": _vm.attachList[0].downUrl
    }
  }, [_c('i', {
    staticClass: "el-icon-my-daochu"
  })])])]) : _c('div', [_c('el-popover', {
    attrs: {
      "placement": "top",
      "title": "简历附件:",
      "width": "200",
      "trigger": "hover"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "text",
      "size": "small"
    },
    slot: "reference"
  }, [_c('span', {
    staticClass: "attachName"
  }, [_vm._v(_vm._s(_vm.attachList[0].name))]), _c('i', {
    staticClass: "el-icon-my-gengduobiaoqian"
  })]), _vm._v(" "), _vm._l((_vm.attachList), function(item, index) {
    return _c('p', {
      key: index,
      staticStyle: {
        "margin": "10px 0"
      }
    }, [(item.preUrl) ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": item.preUrl
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('a', {
      staticClass: "ml-10 mr-10",
      attrs: {
        "href": item.downUrl
      }
    }, [_c('i', {
      staticClass: "el-icon-my-daochu"
    })])])
  })], 2)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b06561b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/attachViewInList.vue
// module id = null
// module chunks = 